import React, { } from 'react'
import { Box, Grid, Link, TextField, MenuItem, BottomNavigationAction } from '@material-ui/core';
import { Field } from 'formik';
import { useStore } from '../../Store'
import Header from '../Header'
import ActionBar from '../ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import Location from '../Location';
import Photos from '../Photos';
import { getErrorProps } from '../../utils';

const ObservationDetails = ({ readonly, formik, handleCancel, handleSubmit }) => {
    const { plots, settings } = useStore()

    const taxLisTaxId = `observation.taxLisTaxId`
    const description = `observation.description`
    const abundance = `observation.abundance`
    const opm_waarneming = `observation.extraInfo.opm_waarneming`
    const location = `observation.location`

    const getTaxa = () => {
        const plot = plots.find(p => p.id === formik.values.plot)
        const taxaList = settings.taxaLists.find(t => t.id === plot.taxaListId)
        return taxaList.taxa.filter(t => t.type === 'row').sort((a, b) => a.sortorder > b.sortorder ? 1 : -1)
    }

    const taxa = getTaxa();

    const species = () => {
        return taxa.map(item => {
            return (
                <MenuItem key={item.id} value={item.id}>
                    {item.name}, {item.name2}
                </MenuItem>
            )
        })
    }

    const changeTaxLisTaxId = (e) => {
        const item = taxa.find(t => t.id === e.target.value)
        formik.setFieldValue(description, item ? `${item.name}, ${item.name2}` : "")
        formik.handleChange(e)
    }


    const getPlot = () => {
        const plot = plots.find(p => p.id === formik.values.plot)
        return plot
    }


    return (
        formik.values.observation &&
        <>
            <Header title={formik.values.observation.description || 'Nieuwe waarneming'} backAction={handleCancel} />
            <Box m={2}>
                <Grid container>

                    <Grid item xs={12}>
                        <TextField required select disabled={readonly} label="soort" variant="standard" name={taxLisTaxId} fullWidth
                            {...formik.getFieldProps(taxLisTaxId)}
                            onChange={changeTaxLisTaxId}
                            {...getErrorProps(formik, taxLisTaxId)}
                        >
                            {species()}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField required disabled={readonly} label="aantal" variant="standard" name={abundance} type="number" fullWidth  {...getErrorProps(formik, abundance)} {...formik.getFieldProps(abundance)} />
                    </Grid>

                    <Grid item xs={12}>
                        <Field id={formik.values.observation.id} disabled={readonly} readonly={readonly} plot={getPlot()} label="location" variant="standard" name={location} errorProps={(name)=>getErrorProps(formik, name)} {...formik.getFieldProps(location)} component={Location} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="opmerkingen" variant="standard" name={opm_waarneming} multiline fullWidth  {...getErrorProps(formik, opm_waarneming)} {...formik.getFieldProps(opm_waarneming)} />
                    </Grid>

                    <Grid item xs={12}>
                        <Photos 
                            uploads={formik.values.observation.uploads} 
                            setUploads={(uploads) => formik.setFieldValue('observation.uploads', uploads)}
                            readonly={readonly}
                            formik={formik}
                        />
                    </Grid>

                </Grid>
            </Box>
            {!readonly &&
                <ActionBar>
                    {!readonly && <BottomNavigationAction label="Waarneming opslaan" component={Link} to="/" onClick={handleSubmit} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
                </ActionBar>}
        </>
    )
}

export default ObservationDetails
